import { query, mutation } from '@/dex-shared/helpers/graphql';
import { normalize } from 'normalizr';
import { video as videoSchema } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async GET_VIDEO_BY_ID({ commit }: any, videoId: number) {
    const response = await query(
      `query VideoById($videoId: Int!){
        videoById(id: $videoId) {
          name
          id
          providerId
          providerType
          duration
          description
        }
      }`,
      {
        videoId,
      },
    );
    const videoInformation = response.data.videoById;
    if (videoInformation) {
      let normalizedResponse = normalize(videoInformation, videoSchema);
      commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
    }
  },
  async UPDATE_VIDEO_BY_ID({ commit }: any, videoContent: Object) {
    return mutation(
      `mutation UpdateVideo ($id: Int!, $providerType: Videoproviderenum,
          $providerId: String, $name: String, $duration: Int, $description: String) {
        updateVideoById(
          input: {
            id: $id
            videoPatch: {
              providerType: $providerType
              providerId: $providerId
              name: $name
              duration: $duration
              description: $description
            }
          }
        ) {
          video {
            id
          }
        }
      }`,
      videoContent,
    );
  },
};
